export default __webpack_public_path__ + "static/media/slash.2c496073.svg";